var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPencilBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 51.021,
    height: 54.015,
    viewBox: "0 0 51.021 54.015",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.672,7.535,41.917,1.428a4.413,4.413,0,0,0-6.5,0l-3.14,3.083,12.256,13,3.14-3.083a5.092,5.092,0,0,0,0-6.9ZM24.044,5.449a3.675,3.675,0,0,0-5.415,0L7.257,17.516a1.7,1.7,0,0,0,0,2.3l2.167,2.3a1.47,1.47,0,0,0,2.167,0L21.338,11.77l2.167,2.3-14.51,15.4A34.075,34.075,0,0,0,.017,49.28l0,.023A2.371,2.371,0,0,0,2.55,52a30.619,30.619,0,0,0,18.7-9.529l18.84-19.991-7.924-8.408-8.123-8.62Z",
    transform: "translate(1.002 1)",
    fill: "none",
    stroke: "#3d5567",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencilBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil-black.6aae2d12.svg";
export { ForwardRef as ReactComponent };